import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { getLogsPage, logActivity } from 'actions/logs';
import { isUserAdministrator } from 'helpers/user';
import Moment from 'moment';
import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { List } from 'UI';

var UserLogs = /*#__PURE__*/function (_Component) {
  _inherits(UserLogs, _Component);

  var _super = _createSuper(UserLogs);

  function UserLogs(props) {
    var _this;

    _classCallCheck(this, UserLogs);

    _this = _super.call(this, props);
    _this.state = {
      startingTicks: '0',
      pageSize: 50,
      loading: false
    };
    return _this;
  }

  _createClass(UserLogs, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$state = this.state,
          startingTicks = _this$state.startingTicks,
          pageSize = _this$state.pageSize; // Log the activity of loading the page

      var logJson = {
        LogType: "Route Change",
        ReferenceType: "Logs Page",
        Comment: "User loaded page"
      };
      this.props.logActivity(logJson); // Get logs

      this.setState({
        loading: true
      });
      this.props.getLogsPage(startingTicks, pageSize).then(function () {
        _this2.setState({
          loading: false
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var loading = this.state.loading;
      var _this$props = this.props,
          translate = _this$props.translate,
          logs = _this$props.logs;
      var admin = isUserAdministrator(this.props.currentUser);

      if (admin) {
        display = /*#__PURE__*/React.createElement(List, {
          title: translate('user-activity')
        }, /*#__PURE__*/React.createElement("table", {
          className: "status-list"
        }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, translate('user')), /*#__PURE__*/React.createElement("th", null, translate('activity')), /*#__PURE__*/React.createElement("th", null, translate('item')), /*#__PURE__*/React.createElement("th", null, translate('item-id')), /*#__PURE__*/React.createElement("th", null, translate('school')), /*#__PURE__*/React.createElement("th", null, translate('time')))), /*#__PURE__*/React.createElement("tbody", null, logs.map(function (log) {
          return /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, log.userName), /*#__PURE__*/React.createElement("td", null, log.logType), /*#__PURE__*/React.createElement("td", null, log.referenceType), /*#__PURE__*/React.createElement("td", null, log.referenceId), /*#__PURE__*/React.createElement("td", null, log.schoolId), /*#__PURE__*/React.createElement("td", {
            style: {
              textAlign: 'left'
            }
          }, Moment(log.timestamp).format("lll")));
        }))));
      } else {
        display = /*#__PURE__*/React.createElement("div", null, translate('unauthorized'), "!");
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "single-task"
      }, display));
    }
  }]);

  return UserLogs;
}(Component);

function mapStateToProps(state) {
  return {
    currentUser: state.user.currentUser,
    logs: state.Logs.logs,
    translate: translate(state.Languages.translations)
  };
}

export default connect(mapStateToProps, {
  getLogsPage: getLogsPage,
  logActivity: logActivity
})(UserLogs);